import { Component, Input, OnInit } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { AgendaNotesFieldComponent } from '../dialog-notes-field/agenda-notes-field.component';
import { PredefinedNotesFieldComponent } from '../dialog-predefined-notes/predefined-notes-field.component';
import { FreeFormAgendaService } from 'src/app/service/free-form-agenda.service';
@Component({
  selector: 'app-agenda-title-more',
  templateUrl: './agenda-title-more.component.html',
  styleUrls: ['./agenda-title-more.component.css']
})
export class AgendaTitleMoreComponent implements OnInit {

  constructor(public dialog: MatDialog,public commonService: FreeFormAgendaService) { }
  @Input()
  agList:any;
  openNotesDialog() {
    const dialogRef = this.dialog.open(AgendaNotesFieldComponent,{
      panelClass : "agenda-notes-field-outer-container",
      width : "50%",
      maxWidth : "100%",
      height : "auto",
      maxHeight : "100vh"
    })
  }
  openPreDefinedDialog() {
    const dialogRef = this.dialog.open(PredefinedNotesFieldComponent,{
      panelClass : "agenda-predefined-notes-field-outer-container",
      width : "50%",
      maxWidth : "100%",
      height : "auto",
      maxHeight : "100vh"
    })
  }
  ngOnInit(): void {
  }

}
